import { render, staticRenderFns } from "./OrderMerge.vue?vue&type=template&id=49965da8&scoped=true"
import script from "./OrderMerge.vue?vue&type=script&lang=js"
export * from "./OrderMerge.vue?vue&type=script&lang=js"
import style0 from "./OrderMerge.vue?vue&type=style&index=0&id=49965da8&prod&scoped=true&lang=css"
import style1 from "./OrderMerge.vue?vue&type=style&index=1&id=49965da8&prod&less=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49965da8",
  null
  
)

export default component.exports